import React, { ComponentProps } from 'react';
import { Route, withRouter, RouteComponentProps } from 'react-router-dom';

import { fomatParentPath } from '../../utils';
import { MobFeedback } from '../../lib';

function Feedback(props: RouteComponentProps & ComponentProps<any>) {
    const parentPath: string = fomatParentPath(props);
    return (
        <Route weId={`${props.weId || ''}_pb8iga`} exact path={`${parentPath}/mobile/uk/feedback`}>
            {
                <MobFeedback weId={`${props.weId || ''}__pz7pga`} />
            }
        </Route>
    )
}

export default withRouter(Feedback);